import { ApartmentOutlined, GlobalOutlined, UserOutlined } from "@ant-design/icons";
import type { RoleScope } from "../types";

/**
 * «Saqlanmagan o'zgarish» belgisi — ro'yxatda, guruh sarlavhasida, chipda
 * va o'zgarishlar tasmasida BIR XIL. Rang yolg'iz belgi emas: olib
 * tashlangan chip qo'shimcha ravishda chizilgan va punktir chegarali.
 */
export function ChangeDot() {
	return (
		<span aria-hidden className="inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-[#e8a317]" />
	);
}

export function ScopeIcon({ scope, className }: { scope: RoleScope; className?: string }) {
	if (scope === "global") {
		return <GlobalOutlined className={className} />;
	}
	if (scope === "department") {
		return <ApartmentOutlined className={className} />;
	}
	return <UserOutlined className={className} />;
}
